var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayStoreIcon = function SvgPlayStoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.58 17.479-5.752 3.32-4.867-4.808 4.814-4.822 5.805 3.352c1.138.656 1.138 2.3 0 2.956v.002Z",
    fill: "#FED400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.83 20.8 5.56 30.769a1.702 1.702 0 0 1-2.073-.283l14.474-14.494 4.867 4.809.001-.001Z",
    fill: "#F83345"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.96 15.99 3.49 30.486A1.681 1.681 0 0 1 3 29.29V2.71c0-.433.155-.811.402-1.102l14.56 14.384h-.001Z",
    fill: "#00D7FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22.775 11.17-4.814 4.822L3.4 1.607a1.707 1.707 0 0 1 2.16-.377l17.214 9.939Z",
    fill: "#00EF77"
  })));
};
export default SvgPlayStoreIcon;